export enum Panel {
  Empty = 'Empty',
  DialKeyboard = 'DialKeyboard',
  DtmfKeyboard = 'DtmfKeyboard',
  WorkstationList = 'WorkstationList',
  InviteToConference = 'InviteToConference',
}
